export default __webpack_public_path__ + "static/ue-logo-2-2612d3d90ddbb7e26d9ebe32ab3b1f1a.svg";